import { Popover, PopoverContent, PopoverTrigger } from "@/modern/components/ui/popover";
import { ViewStateInspection } from "@/modern/components/editors/viewEditor/tabs/ViewStateInspection";
import { useState, ReactNode, cloneElement, isValidElement } from "react";

interface ViewStateInspectionPopupProps {
  children: ReactNode;
  viewRecord: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  context: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

export const ViewStateInspectionPopup = ({
  children,
  viewRecord,
  context
}: ViewStateInspectionPopupProps) => {
  const [open, setOpen] = useState(false);

  if (!viewRecord) return <>{children}</>;

  // Clone the child element and add hover handlers
  const triggerElement = isValidElement(children)
    ? cloneElement(children as React.ReactElement<any>, { // eslint-disable-line @typescript-eslint/no-explicit-any
        onMouseEnter: () => setOpen(true),
        onMouseLeave: () => setOpen(false),
      })
    : children;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        {triggerElement}
      </PopoverTrigger>
      <PopoverContent
        side="bottom"
        align="end"
        className="w-[300px] p-2"
        onOpenAutoFocus={(e) => e.preventDefault()}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        <ViewStateInspection
          record={viewRecord}
          context={context}
          canUseRecordViewState={false}
          hideRemoveButtons={true}
          className="max-h-[400px]"
        />
      </PopoverContent>
    </Popover>
  );
};
